import {BrowserRouter, Routes, Route} from 'react-router';
import App from './App';
import ContainerPadding from './components/ContainerPadding';
import ContainerWithoutPadding from './components/ContainerWithoutPadding';
import Home from './routes/Home';
import Landing from './routes/Landing';
import Membership from './routes/Membership';
import Login from './routes/Login';
import Signup from './routes/Signup';
import ForgetPassword from './routes/ForgetPassword';
import UpdatePassword from './routes/UpdatePassword';
import Account from './routes/Account';
import OralPhotos from './routes/OralPhotos';
import OralPhotosEditor from './routes/OralPhotosEditor';
import OralPhotosAdd from './routes/OralPhotosAdd';
import Appointments from './routes/Appointments';
import AppointmentAdd from './routes/AppointmentAdd';
import AppointmentEditor from './routes/AppointmentEditor';
import AppointmentDetail from './routes/AppointmentDetail';
import MedicalRecords from './routes/MedicalRecords';
import MedicalRecordsAdd from './routes/MedicalRecordsAdd';
import MedicalRecordsEdit from './routes/MedicalRecordsEdit';
import DentalKnowledgement from './routes/DentalKnowledgement';
import DentalKnowledgementArticle from './routes/DentalKnowledgementArticle';
import OralSuppliers from './routes/OralSuppliers';
import OralSupplierContent from './routes/OralSupplierContent';
import DentalAi from './routes/DentalAi';
import VirtualConsultation from './routes/VirtualConsultation';
import ReservationHistory from './routes/ReservationHistory';
import DentistAvailability from './routes/DentistAvailability';
import Assessments from './routes/Assessments';
import PrivacyPolicy from './routes/PrivacyPolicy';
import TeethWhitening from './routes/TeethWhitening';
import RequireAuth from './RequireAuth';
import AuthCallback from './routes/AuthCallback';
import MembershipCheckout from './routes/MembershipCheckout';
import ConsultationBook from './routes/ConsultationBook';
import {LegacyRoomRedirect, LegacySummaryRedirect, RoomRoute} from './routes/ConsultationLinks';
import DoctorReservations from './routes/DoctorReservations';
import NotFound from './routes/NotFound';

export const AppRoutes = () => {
  return (
    // Navigation stays synchronous, as it was on React 17: a transition would keep the old page
    // mounted (and its polls running) for a few more ms after the user has left it.
    <BrowserRouter useTransitions={false}>
      <Routes>
        <Route element={<RequireAuth />}>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path="membership" element={<Membership />} />
            <Route path="membership/checkout/:paymentId" element={<MembershipCheckout />} />
            <Route path="account" element={<Account />} />
            <Route path="whitening" element={<TeethWhitening />} />
            <Route path="assessments" element={<ContainerPadding />}>
              <Route index element={<Assessments />} />
            </Route>
            <Route path="oral-photo" element={<ContainerPadding />}>
              <Route index element={<OralPhotos />} />
              <Route path="add" element={<OralPhotosAdd />} />
              <Route name="oral-edit" path=":oralPhotoId/edit" element={<OralPhotosEditor />} />
            </Route>
            <Route path="appointments" element={<ContainerPadding />}>
              <Route index element={<Appointments />} />
              <Route path="add" element={<AppointmentAdd />} />
              <Route path=":appointmentId" element={<AppointmentDetail />} />
              <Route name="appointment-edit" path=":appointmentId/edit" element={<AppointmentEditor />} />
            </Route>
            <Route path="dental-records" element={<ContainerPadding />}>
              <Route index element={<MedicalRecords />} />
              <Route path="add" element={<MedicalRecordsAdd />} />
              <Route path=":medicalRecordId" element={<MedicalRecordsEdit />} />
            </Route>
            <Route path="dental-education" element={<ContainerWithoutPadding />}>
              <Route index element={<DentalKnowledgement />} />
              <Route path=":knowledgeId" element={<DentalKnowledgementArticle />} />
            </Route>
            <Route path="oral-supplier" element={<ContainerWithoutPadding />}>
              <Route index element={<OralSuppliers />} />
              <Route path=":supplierId" element={<OralSupplierContent />} />
            </Route>
            <Route path="virtual-consultation" element={<ContainerWithoutPadding />}>
              <Route index element={<VirtualConsultation />} />
              <Route path="reservation-record" element={<ReservationHistory />} />
              <Route path="book" element={<ConsultationBook />} />
              <Route path="room" element={<LegacyRoomRedirect />} />
              <Route path="room/:reservationId" element={<RoomRoute />} />
              <Route path="summary" element={<LegacySummaryRedirect />} />
              <Route path="doctor" element={<DoctorReservations />} />
            </Route>
            <Route path="dental-ai" element={<ContainerWithoutPadding />}>
              <Route index element={<DentalAi />} />
            </Route>
            <Route path="dentist/availability" element={<ContainerPadding />}>
              <Route index element={<DentistAvailability />} />
            </Route>
          </Route>
        </Route>
        <Route path="auth/callback" element={<AuthCallback />} />
        <Route path="landing" element={<Landing />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="forget-password" element={<ForgetPassword />} />
        <Route path="update-password" element={<UpdatePassword />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
